import { render, staticRenderFns } from "./formulator-slide-and-select-additive.vue?vue&type=template&id=5394a5e6&"
import script from "./formulator-slide-and-select-additive.vue?vue&type=script&lang=js&"
export * from "./formulator-slide-and-select-additive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports